import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordHierarchyIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_38497_397)">
        <path
          d="M6.00003 4.07139C7.09717 4.07139 7.71431 3.45425 7.71431 2.35711C7.71431 1.25997 7.09717 0.642822 6.00003 0.642822C4.90288 0.642822 4.28574 1.25997 4.28574 2.35711C4.28574 3.45425 4.90288 4.07139 6.00003 4.07139Z"
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.9286 11.3571C2.75145 11.3571 3.21431 10.8943 3.21431 10.0714C3.21431 9.24854 2.75145 8.78568 1.9286 8.78568C1.10574 8.78568 0.642883 9.24854 0.642883 10.0714C0.642883 10.8943 1.10574 11.3571 1.9286 11.3571Z"
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.00003 11.3571C6.82288 11.3571 7.28574 10.8943 7.28574 10.0714C7.28574 9.24854 6.82288 8.78568 6.00003 8.78568C5.17717 8.78568 4.71431 9.24854 4.71431 10.0714C4.71431 10.8943 5.17717 11.3571 6.00003 11.3571Z"
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0715 11.3571C10.8943 11.3571 11.3572 10.8943 11.3572 10.0714C11.3572 9.24854 10.8943 8.78568 10.0715 8.78568C9.2486 8.78568 8.78574 9.24854 8.78574 10.0714C8.78574 10.8943 9.2486 11.3571 10.0715 11.3571Z"
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.71429 8.7857V7.92855C1.71429 6.98178 2.48181 6.21427 3.42858 6.21427H8.57144C9.51824 6.21427 10.2857 6.98178 10.2857 7.92855V8.7857M6.00001 4.07141V8.7857"
          stroke={stroke || bordColorTheme.navyBlue[400]}
        />
      </g>
      <defs>
        <clipPath id="clip0_38497_397">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BordHierarchyIcon;
